import dayjs from "dayjs";
import type { LookupValue } from "src/services/deviceDetailsService";

export const formatDate = (value?: string) =>
  value && dayjs(value).isValid() ? dayjs(value).format("DD/MM/YYYY") : "";

export const toOptions = (values?: LookupValue[]) =>
  (values ?? []).map((item) => ({
    value: item.id ?? item.value ?? item.code ?? "",
    label: item.name ?? item.label ?? item.code ?? String(item.id ?? item.value ?? ""),
    item,
  }));

export const toInteger = (value: unknown): number | null => {
  if (value === "" || value === undefined || value === null) return null;
  const number = Number.parseInt(String(value), 10);
  return Number.isNaN(number) ? null : number;
};

export const toFloat = (value: unknown): number | null => {
  if (value === "" || value === undefined || value === null) return null;
  const number = Number.parseFloat(String(value));
  return Number.isNaN(number) ? null : number;
};

export const valueId = (value: unknown): string | number | undefined => {
  if (typeof value === "string" || typeof value === "number") return value;
  if (value && typeof value === "object" && "id" in value) {
    const id = (value as { id?: unknown }).id;
    return typeof id === "string" || typeof id === "number" ? id : undefined;
  }
  return undefined;
};

export const lookupValues = (value: unknown): LookupValue[] => {
  if (Array.isArray(value)) return value as LookupValue[];
  if (!value || typeof value !== "object") return [];
  const record = value as Record<string, unknown>;
  return lookupValues(record.response ?? record.data);
};

export const haveFormValuesChanged = <T extends object>(
  initialValues: T,
  currentValues: Partial<T>,
) => {
  const keys = new Set([
    ...Object.keys(initialValues),
    ...Object.keys(currentValues),
  ]);

  return [...keys].some(
    (key) =>
      !Object.is(
        initialValues[key as keyof T],
        currentValues[key as keyof T],
      ),
  );
};
